import { routesPathConstants } from "./routesPath.constant";
export const SIDEBAR_BUTTONS = {
  DASHBOARD: "DASHBOARD",
  SELL_AND_TRADE: "SELL_AND_TRADE",
  INVENTORY: "INVENTORY",
  ANALYTICS: "ANALYTICS",
  USERS: "USERS",
  CUSTOMERS: "CUSTOMERS",
  SETTINGS: "SETTINGS",
  ADMIN: "ADMIN",
  ORDERS: "ORDERS",
};

export const NESTED_SIDEBAR_OPTIONS = {
  DASHBOARD: [],
  SELL_AND_TRADE: [
    {
      name: "New Transaction",
      route: routesPathConstants.SELL_AND_TRADE_NEW_TRANSACTION,
    },
    {
      name: "New Return",
      route: routesPathConstants.SELL_AND_TRADE_NEW_RETURN,
    },
    {
      name: "Online Orders",
      route: routesPathConstants.SELL_AND_TRADE_ORDERS,
    },
    {
      name: "Open/Close",
      route: routesPathConstants.SELL_AND_TRADE_OPEN_CLOSE_REGISTER,
    },
    {
      name: "Cash Management",
      route: routesPathConstants.SELL_AND_TRADE_CASH_MANAGEMENT,
    },
    {
      name: "Register Sessions",
      route: routesPathConstants.SELL_AND_TRADE_REGISTER_SESSIONS,
    },
    { name: "History", route: routesPathConstants.SELL_AND_TRADE_HISTORY },
    { name: "Drafts", route: routesPathConstants.SELL_AND_TRADE_DRAFTS },
  ],
  INVENTORY: [
    { name: "Items", route: routesPathConstants.INVENTORY_ITEMS },
    { name: "History", route: routesPathConstants.INVENTORY_ITEMS_HISTORY },
    {
      name: "Price Changes",
      route: routesPathConstants.INVENTORY_ITEMS_PRICE_CHANGES,
    },
    {
      name: "Invoices",
      route: routesPathConstants.INVENTORY_INVOICES,
    },
  ],
  ANALYTICS: [
    {
      name: "Sales Summary",
      route: routesPathConstants.ANALYTICS_SALES_SUMMARY,
    },
  ],
  USERS: [],
  CUSTOMERS: [],
  SETTINGS: [
    { name: "Devices", route: routesPathConstants.SETTINGS_DEVICES },
    { name: "Discounts", route: routesPathConstants.SETTINGS_DISCOUNT },
    { name: "Trade-Ins", route: routesPathConstants.SETTINGS_TRADE_INS },
    {
      name: "Item Organization",
      route: routesPathConstants.SETTINGS_ITEM_ORGANIZATION,
    },
    {
      name: "Price Markups",
      route: routesPathConstants.SETTINGS_PRESET_PRICES,
    },
    {
      name: "Store Settings",
      route: routesPathConstants.SETTINGS_RECEIPT_AND_LABELS,
    },
    {
      name: "Outlets",
      route: routesPathConstants.SETTINGS_OUTLETS,
    },
    {
      name: "Shopify Connection",
      route: routesPathConstants.SETTINGS_SHOPIFY_CONNECTION,
    },
    {
      name: "Shopify Presets",
      route: routesPathConstants.SETTINGS_SHOPIFY_PRESETS,
    },
  ],
  ADMIN: [
    { name: "Stores", route: routesPathConstants.ADMIN_STORES },
    { name: "Companies", route: routesPathConstants.ADMIN_COMPANIES },
    { name: "Devices", route: routesPathConstants.ADMIN_DEVICES },
    { name: "Superadmins", route: routesPathConstants.ADMIN_SYSTEMUSERS },
  ],
};
